import firestore from '../firestore'
import { findNoteHelper } from '../../js/noteTemplates/noteHelpers'
import Vue from 'vue'

// function processOnSave (item) {
//   let noteHelper = findNoteHelper(item.id)
//   // let ti = noteHelper.getFormattedTreeItem()
//   return noteHelper.onSave(item)
//   // let template = store.getters.findNoteTemplate((item.userData || {}).templateId)
//   // if ((template || {}).onSave) {
//   //   return Promise.resolve(template.onSave(item)) // returns a promise
//   // }
//   // return Promise.resolve(item)
// }

// Returns a promise with the new item's id as a parameter
export const addItem = ({ state, dispatch }, { item, parentItemId }) => {
  item.createdAt = new Date()
  let ref = firestore.itemsColRef.doc()
  return ref.set(item).then(() => {
    if (parentItemId == null) {
      return dispatch('addRootChild', { childId: ref.id }).then(() => { return ref.id })
    } else {
      return dispatch('addChildToItem', { parentItemId, childId: ref.id }).then(() => { return ref.id })
    }
  })
}

export const updateItemProperty = ({ state, dispatch }, { itemId, propName, propNewValue }) => {
  let clone = Object.assign({}, state.items[itemId])
  clone[propName] = propNewValue
  return dispatch('updateItem', clone)
}

export const updateItemData = ({ state, dispatch }, { itemId, newData }) => {
  return dispatch('updateItemProperty', { itemId, propName: 'data', propNewValue: newData })
}

export const updateItem = ({ commit }, item) => {
  let clone = Object.assign({}, item)
  delete clone['id']
  // console.log('SET note ' + item.id)
  return firestore.itemsColRef.doc(item.id).set(clone)
  // let clone = Object.assign({}, item)
  // return processOnSave(clone).then((processedClone) => {
  //   delete processedClone['id']
  //   return firestore.itemsColRef.doc(item.id).set(processedClone)
  // })
}

export const updateItemAddToBatch = ({ commit }, { item, batch }) => {
  let clone = Object.assign({}, item)
  delete clone['id']
  return batch.set(firestore.itemsColRef.doc(item.id), clone)
}

export const addChildToItem = ({ state }, { parentItemId, childId }) => {
  let parentItem = state.items[parentItemId]
  let clone = Object.assign({}, parentItem)
  delete clone['id']
  if (!('children' in clone)) clone['children'] = []
  clone['children'].push(childId)
  return firestore.itemsColRef.doc(parentItemId).set(clone)
}

export const updateItemChildren = ({ state }, { noteId, newChildIds }) => {
  let item = state.items[noteId]
  let clone = Object.assign({}, item)
  delete clone['id']
  clone.children = newChildIds
  return firestore.itemsColRef.doc(noteId).set(clone)
}

export const removeChildFromItem = ({ state }, { parentItemId, childId }) => {
  let parentItem = state.items[parentItemId]
  let clone = Object.assign({}, parentItem)
  delete clone['id']
  if (!('children' in clone)) clone['children'] = []
  let index = clone['children'].indexOf(childId)
  if (index === -1) return null
  clone['children'].splice(index, 1)

  return firestore.itemsColRef.doc(parentItemId).set(clone)
}

function removeChildFromItemToBatch (rootState, parentItemId, childId, batch) {
  if (parentItemId == null) {
    let clone = Object.assign({}, rootState.auth.currentUser)
    delete clone['uid']
    let index = clone['rootItems'].indexOf(childId)
    if (index === -1) return null
    clone['rootItems'].splice(index, 1)
    batch.set(firestore.userDocRef, clone)
  } else {
    let parentItem = rootState.items.items[parentItemId]
    let parentNoteHelper = findNoteHelper(parentItemId)
    const indexInTreeItem = parentNoteHelper.formattedTreeItem.children.findIndex(item => item.id === childId)
    if (indexInTreeItem >= 0) {
      Vue.delete(parentNoteHelper.formattedTreeItem.children, indexInTreeItem)
    }
    let clone = Object.assign({}, parentItem)
    delete clone['id']
    if (!('children' in clone)) clone['children'] = []
    let index = clone['children'].indexOf(childId)
    if (index === -1) return null
    clone['children'].splice(index, 1)
    batch.set(firestore.itemsColRef.doc(parentItemId), clone)
  }
}

export const deleteItemWithId = ({ rootState, getters, commit, dispatch }, itemId) => {
  let parents = getters.getParents(itemId)
  let batch = firestore.db.batch()

  parents.forEach((parentId) => {
    removeChildFromItemToBatch(rootState, parentId, itemId, batch)
  })
  batch.delete(firestore.itemsColRef.doc(itemId))
  return batch.commit()
}

export const setTreeRoot = async ({ state, rootState, getters, commit, dispatch }, rootId) => {
  if (rootId === state.navTreeRootId) return
  commit('buildNavTree', rootId)
  commit('setNavTreeRootId', rootId)
}
